<template>
    <div class="check-list-item-row" :class="rowClass">
        <branch-list-item :item="branch"
                          :draggable="draggable"
                          :class="branchClass"
                          :view="view"
                          :value="branchValue"
                          @input="branchChange($event)"
                          @open="handleClick">
            <controls-dropdown v-if="!view"
                               @click="clickControls($event, null)"
                               :visible-controls="visibleControlsId"
                               :actions="branchActions"
                               :item-id="branch.id"></controls-dropdown>
        </branch-list-item>
        <dropdown-item-component class="check-list-dropdown" :visible="opened">
            <branch-list-item v-for="(list, index) in branch.lists"
                              :key="index"
                              :class="isActive(list.id) + listItemClass(index)"
                              :draggable="false"
                              :view="view"
                              :item="list"
                              :value="value[index]"
                              @open="$emit('list-click', list.id)"
                              @input="listChange($event, index)">
                <controls-dropdown v-if="!view"
                                   :visible-controls="visibleControlsId"
                                   :actions="getActions(list.favorite)"
                                   :item-id="list.id"
                                   @click="clickControls($event, index)"
                ></controls-dropdown>
            </branch-list-item>
        </dropdown-item-component>
    </div>
</template>

<script>
    import DropdownItemComponent from "../common/Dropdown";
    import ControlsDropdown from "../MainPage/ControlsDropdown";
    import {mapState, mapMutations} from 'vuex'
    //import PostDate from "../KnowledgeBase/PostDate";
    import BranchListItem from "./BranchListItem";

    export default {
        name: 'branch-item',
        components: {
            BranchListItem,
            //PostDate,
            ControlsDropdown,
            DropdownItemComponent
        },
        props: {
            branchActions: Array,
            listActions: Array,
            branch: Object,
            view: Boolean,
            draggable: {
                type: Boolean,
                default: false
            },
            value: {
                type: Array,
                default: () => {
                    return []
                }
            }

        },
        data () {
            return {
                opened: false,
                branchValue: false,
                openedControls: false,
                openedControlsItemIndex: null
            }
        },
        computed: {
            ...mapState({
                activeList: state => state.checkLists.activeList,
                visibleControlsId: state => state.checkLists.visibleControlsId
            }),
            rowClass() {
                let css = this.opened ? 'opened-dropdown' : '';
                css += this.openedControls === this.visibleControlsId ? ' higher-index' : '';
                return css
            },
            branchClass() {
                let css = 'js-open-dropdown';
                css += this.openedControls === this.visibleControlsId ? ' opened-controls' : '';
                return css
            },
        },
        methods: {
            ...mapMutations('checkLists', [
                'setControlsVisibility'
            ]),
            closeClick() {
                this.$emit('update:active', false)
            },
            handleClick() {
                this.opened = !this.opened
            },
            isActive(id) {
                return this.activeList.id && id === this.activeList.id ? 'active' : ''
            },
            clickControls(e, index) {
                if (this.visibleControlsId !== e) {
                    this.openedControls = e;
                    this.openedControlsItemIndex = index;
                    this.setControlsVisibility(e);
                } else {
                    this.setControlsVisibility(null);
                }
            },
            isChecked(list) {
                return list.total === list.count
            },
            branchChange(e) {
                this.branchValue = e;
                let val = Object.assign([],this.value);
                this.branch.lists.forEach((list, index) => {
                    val[index]= e;
                });
                this.$emit('change', val)
            },
            listChange(e, index) {

                let val = Object.assign([],this.value);
                //val.splice(index, 1, e)
                val[index] = e;
                this.$emit('change', val);
                if(!e) {
                   this.branchValue = false
                }
            },
            listItemClass(index) {
                return this.openedControls === this.visibleControlsId && this.openedControlsItemIndex === index ? ' opened-controls' : '';
            },
            //нужно для изменения надписи в избранное на удалить из избранного
            getActions(isFavorite) {
                let newActions = [];
                if (isFavorite) {
                    this.listActions.forEach((action) => {
                        let act = Object.assign({}, action);
                        if (action.action === 'checkLists/setFavorite' && isFavorite) {
                            act.title = 'Удалить из избранного';
                        }
                        newActions.push(act);

                    });
                    return newActions
                }
                return this.listActions
            }
        },
    }
</script>

<style scoped>

</style>
